// PWA install tracking ("Get the app" banner).
//
// GA4 has no recommended event for web-app installation, so these stay custom
// — bending something like sign_up to fit would corrupt a standard report.
// They now route through track() so every event in the app shares one path.
//
// Event names used by the banner:
//   pwa_banner_impression        - the banner became visible
//   pwa_banner_install_click     - the Install CTA was tapped
//   pwa_banner_install_accepted  - native install prompt accepted
//   pwa_banner_install_dismissed - native install prompt dismissed
//   pwa_banner_ios_steps_shown   - iOS "Add to Home Screen" steps expanded
//   pwa_banner_close             - the X / cross button was tapped
//   app_installed                - the OS actually completed the install
//   app_launch_standalone        - the app was opened from the home screen
//
// The same names are reused by the PwaInstall modal (the header device icon),
// tagged surface:'modal' so the banner and the modal stay separable. The modal
// additionally owns the push opt-out, which no other surface records:
//   pwa_modal_open               - the install/notifications modal was opened
//   push_disabled                - notifications were switched back off
//   push_disable_failed          - the unsubscribe request failed
import { track } from "@/lib/track";

export const trackPwa = (action, extra = {}) => {
  if (!action) return;
  track(action, {
    event_category: "PWA Install",
    event_label: action,
    ...extra,
  });
};
